import {
  WmsAdjustReason,
  WmsAdjustReasonLabels,
  WmsAllocationStatus,
  WmsAllocationStatusLabels,
  WmsAvailabilitySource,
  WmsAvailabilitySourceLabels,
  WmsCycleCountStatus,
  WmsCycleCountStatusLabels,
  WmsIssueType,
  WmsIssueTypeLabels,
  WmsMovementType,
  WmsMovementTypeLabels,
  WmsRefType,
  WmsRefTypeLabels,
  WmsReservationStatus,
  WmsReservationStatusLabels,
  WmsTransferStatus,
  WmsTransferStatusLabels
} from '@navio/nsdk';
import { entriesToOptions, getLabelMapFromEntries } from './choiceOptions';

// US English spelling and shorter UI wording for the generated Django labels
const CYCLE_COUNT_STATUS_LABELS = { ...WmsCycleCountStatusLabels, CANCELLED: 'Canceled' };
const TRANSFER_STATUS_LABELS = { ...WmsTransferStatusLabels, CANCELLED: 'Canceled' };
const REF_TYPE_LABELS = { ...WmsRefTypeLabels, MANUAL: 'Manual', WMS_TRANSFER: 'Warehouse transfer' };

export const WMS_RESERVATION_STATUS_ICON = {
  [WmsReservationStatus.ACTIVE]: 'Lock',
  [WmsReservationStatus.CONSUMED]: 'PackageCheck',
  [WmsReservationStatus.EXPIRED]: 'Clock',
  [WmsReservationStatus.RELEASED]: 'LockOpen'
} as const satisfies Record<WmsReservationStatus, string>;

export const WMS_RESERVATION_STATUS_OPTIONS = entriesToOptions(WmsReservationStatus, WmsReservationStatusLabels).map(
  (option) => ({
    ...option,
    icon: WMS_RESERVATION_STATUS_ICON[option.value]
  })
);
export const WMS_RESERVATION_STATUS_LABEL_MAP = getLabelMapFromEntries(
  WmsReservationStatus,
  WmsReservationStatusLabels
);

export const WMS_ALLOCATION_STATUS_OPTIONS = entriesToOptions(WmsAllocationStatus, WmsAllocationStatusLabels);
export const WMS_ALLOCATION_STATUS_LABEL_MAP = getLabelMapFromEntries(WmsAllocationStatus, WmsAllocationStatusLabels);

export const WMS_AVAILABILITY_SOURCE_LABEL_MAP = getLabelMapFromEntries(
  WmsAvailabilitySource,
  WmsAvailabilitySourceLabels
);

export const WMS_CYCLE_COUNT_STATUS_OPTIONS = entriesToOptions(WmsCycleCountStatus, CYCLE_COUNT_STATUS_LABELS);
export const WMS_CYCLE_COUNT_STATUS_LABEL_MAP = getLabelMapFromEntries(WmsCycleCountStatus, CYCLE_COUNT_STATUS_LABELS);

export const WMS_TRANSFER_STATUS_LABEL_MAP = getLabelMapFromEntries(WmsTransferStatus, TRANSFER_STATUS_LABELS);

export const WMS_REF_TYPE_OPTIONS = entriesToOptions(WmsRefType, REF_TYPE_LABELS);
export const WMS_REF_TYPE_LABEL_MAP = getLabelMapFromEntries(WmsRefType, REF_TYPE_LABELS);

export const WMS_ADJUST_REASON_OPTIONS = entriesToOptions(WmsAdjustReason, WmsAdjustReasonLabels);

export const WMS_ISSUE_TYPE_LABEL_MAP = getLabelMapFromEntries(WmsIssueType, WmsIssueTypeLabels);

const WMS_MOVEMENT_TYPE_ICON = {
  [WmsMovementType.ADJUST]: 'ClipboardCheck',
  [WmsMovementType.ALLOCATE]: 'PackageCheck',
  [WmsMovementType.DEALLOCATE]: 'PackageMinus',
  [WmsMovementType.RECEIPT]: 'PackagePlus',
  [WmsMovementType.RELEASE]: 'LockOpen',
  [WmsMovementType.RESERVE]: 'Lock',
  [WmsMovementType.SALE]: 'ShoppingCart',
  [WmsMovementType.SCRAP]: 'Trash2',
  [WmsMovementType.TRANSFER_IN]: 'ArrowDown',
  [WmsMovementType.TRANSFER_OUT]: 'ArrowUp'
} as const satisfies Record<WmsMovementType, string>;

export const WMS_MOVEMENT_TYPE_OPTIONS = entriesToOptions(WmsMovementType, WmsMovementTypeLabels).map((option) => ({
  ...option,
  icon: WMS_MOVEMENT_TYPE_ICON[option.value]
}));
export const WMS_MOVEMENT_TYPE_LABEL_MAP = getLabelMapFromEntries(WmsMovementType, WmsMovementTypeLabels);
